var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"registroDeDiploma"}},[_c('Banner',{attrs:{"nomePagina":"Registro de Diploma"}}),_c('Conteudo'),_c('Inscricao')],1)}
var staticRenderFns = []

export { render, staticRenderFns }